interface AudioSessionLike {
  type: string
}

/** Voice messages being recorded: while any is, the session keeps the microphone. */
let recordings = 0

function apply(type: string): void {
  const session = (navigator as Navigator & { audioSession?: AudioSessionLike }).audioSession
  if (session && session.type !== type) session.type = type
}

// How this page's sound behaves on iPhones and iPads (Safari's Audio Session API; other browsers ignore it).

/** A clip someone starts plays out loud, even with the silent switch on. */
export function playbackAudio(): void {
  if (recordings === 0) apply('playback')
}

/**
 * Notification sounds keep to the silent switch, unless a clip is playing out loud: called before one plays, and when a
 * clip stops. (A clip removed from the page as it plays stops without saying so to the page.)
 */
export function ambientAudio(doc: Pick<Document, 'querySelectorAll'> = document): void {
  if (recordings > 0) return
  if ([...doc.querySelectorAll<HTMLMediaElement>('video, audio')].some((element) => !element.paused)) return
  apply('ambient')
}

/** Recording a voice message takes the microphone as well. Returns what to call once it's over; calling it again does nothing. */
export function holdRecordingAudio(): () => void {
  recordings++
  apply('play-and-record')
  let held = true
  return () => {
    if (!held) return
    held = false
    recordings--
    ambientAudio()
  }
}
